// USDT Contract Addresses (Mainnet)
export const USDT_CONTRACTS = {
    // Tron TRC20 USDT
    TRON: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',

    // Ethereum ERC20 USDT
    ETHEREUM: '0xdAC17F958D2ee523a2206206994597C13D831ec7',

    // Polygon USDT
    POLYGON: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',

    // Solana SPL USDT
    SOLANA: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'
} as const

// Treasury Addresses (Production)
export const TREASURY_ADDRESSES = {
    TRON: 'TZ34giD1jpEVHNYDzo2Spm7jS5iZoXFZrn', // User provided
    ETHEREUM: '0x72859907794A47e07ae2b63C26fF0a837263dadD',
    POLYGON: '0x72859907794A47e07ae2b63C26fF0a837263dadD',
    SOLANA: '673Y2RSm5fMQ3V6LbzmBf5NVb4f2asKv4vPL878sJoUH',
    BITCOIN: 'bc1qn9dll5qzv2x5mchlzmp5xc63l2pua8f9nl5xve'
} as const

// USDT Decimals
export const USDT_DECIMALS = {
    TRON: 6,
    ETHEREUM: 6,
    POLYGON: 6,
    SOLANA: 6
} as const
